import { Component, OnInit, AfterViewInit, ViewChildren, QueryList, ElementRef } from '@angular/core';
import { SafeHtml, SafeResourceUrl, DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { FundrecommService } from 'src/app/services/fundrecomm.service';
import 'dotdotdot-js'
@Component({
  selector: 'app-newsletter-detail',
  templateUrl: './newsletter-detail.component.html',
  styleUrls: ['./newsletter-detail.component.scss']
})
export class NewsletterDetailComponent implements OnInit, AfterViewInit {
  @ViewChildren('insertDotdotdot') insertDotdotdot: QueryList<ElementRef>
  constructor(private route: ActivatedRoute, private _mainService: FundrecommService,
    private _sanitizer: DomSanitizer) { }
  language = JSON.parse(localStorage.getItem('language'))
  pageHeaderStyle = {};
  backgroundPath = 'assets/images/lead/default@2x.png';


  newsletter: any;
  shownewsletter: any;
  detail: any;
  file_pdf: string;
  newsletterTitle: string;
  newsletterType: string;
  newsletterDate: string;
  pdfUrl_path: any;
  pdfUrl: any;

  id: any;
  private player;
  private ytEvent;
  filesize: any;

  flag: any

  ngOnInit() {
    this.flag = localStorage.getItem("language_flag")

    this.newsletter = this.route.params.subscribe(params => {
      this._mainService.get_newsletterById(params['id']).subscribe(response => {
        //case news type is text
        if (this.flag == 'th') {
          if (response[0].newsletter_type === 'text') {
            this.file_pdf = 'no';
            response[0].detail = this.htmlTransforms(response[0].detail);
            this.detail = this.htmlTransforms(response[0].detail);

            this.shownewsletter = response;
            this.newsletterTitle = response[0].title;
            this.newsletterType = response[0].newsletter_type;
            this.newsletterDate = this._mainService.date_thai(response[0].publicDate);

          } else if (response[0].newsletter_type === 'image') {
            this.file_pdf = 'no';
            this.shownewsletter = response;
            this.detail = response[0].detail;
            this.newsletterTitle = response[0].title;
            this.newsletterType = response[0].newsletter_type;
            this.newsletterDate = this._mainService.date_thai(response[0].publicDate);

          } else if (response[0].newsletter_type === 'pdf') {
            this.file_pdf = 'yes';
            this.pdfUrl_path = response[0].detail;
            this.shownewsletter = response;
            this.pdfUrl = this.urlTransform(response[0].detail);
            this.newsletterTitle = response[0].title;
            this.newsletterType = response[0].newsletter_type;
            this.filesize = response[0].filesize
            this.newsletterDate = this._mainService.date_thai(response[0].publicDate);

          }
          else if (response[0].newsletter_type === 'vdo') {
            this.file_pdf = 'no';
            this.shownewsletter = response;
            this.detail = response[0].detail;
            this.id = response[0].detail;
            this.newsletterTitle = response[0].title;
            this.newsletterType = response[0].newsletter_type;
            this.newsletterDate = this._mainService.date_thai(response[0].publicDate);

          }
        } else {
          if (response[0].newsletter_type === 'text') {
            this.file_pdf = 'no';
            response[0].detail_en = this.htmlTransforms(response[0].detail_en);
            this.detail = this.htmlTransforms(response[0].detail_en);
          
            this.shownewsletter = response;
            this.newsletterTitle = response[0].title_en;
            this.newsletterType = response[0].newsletter_type;
            this.newsletterDate = response[0].publicDate;

          } else if (response[0].newsletter_type === 'image') {
            this.file_pdf = 'no';
            this.shownewsletter = response;
            this.detail = response[0].detail_en;
            this.newsletterTitle = response[0].title_en;
            this.newsletterType = response[0].newsletter_type;
            this.newsletterDate = response[0].publicDate;

          } else if (response[0].newsletter_type === 'pdf') {
            this.file_pdf = 'yes';
            this.pdfUrl_path = response[0].detail_en;
            this.shownewsletter = response;
            this.pdfUrl = this.urlTransform(response[0].detail_en);
            this.newsletterTitle = response[0].title_en;
            this.newsletterType = response[0].newsletter_type;
            this.filesize = response[0].filesize
            this.newsletterDate = response[0].publicDate;

          }
          else if (response[0].newsletter_type === 'vdo') {
            this.file_pdf = 'no';
            this.shownewsletter = response;
            this.detail = response[0].detail_en;
            this.id = response[0].detail_en;
            this.newsletterTitle = response[0].title_en;
            this.newsletterType = response[0].newsletter_type;
            this.newsletterDate = response[0].publicDate;
          }
        }
      })
    })

    this.pageHeaderStyle = {
      'background-image': 'url(' + this.backgroundPath + ')',
      'height': `360px`,
    }
  }

  ngAfterViewInit() {
    this.insertDotdotdot.changes.subscribe(() => {
      this.insertDotdotdot.toArray().forEach(el => {
        $(el.nativeElement).dotdotdot({
          truncate: "letter",
          watch: true,
        })
      })
    })
  }

  ngOnDestroy() {
    this.newsletter.unsubscribe();
  }

  htmlTransforms(value: string): SafeHtml {
    return this._sanitizer.bypassSecurityTrustHtml(value)
  }

  urlTransform(value): SafeResourceUrl {
    return this._sanitizer.bypassSecurityTrustResourceUrl(value)
  }
  onStateChange(event) {
    this.ytEvent = event.data;
  }
  savePlayer(player) {
    this.player = player;
  }
}